export enum ApiEnv { Production = 1, Beta, Stable }
export enum Role { angelOrGod = 1, member, advertiser, publisher, api, angel, exchange }
export enum RoleType { AdvertiserManager = 1, PublisherManager, AdvertiserAffiliation, GuestManager, Guest }
export enum SupplyType { Site = 1, App, Both }
export enum BudgetType { Unlimited = 1, Capped, AdjustedCap, }
export enum BudgetMode { FlatCPM = 1, OptimizedCPM, FlatCPC, }
export enum Pace { SpendEvenlyDay = 1, SpendAsFastAsPossible, }
export enum Device { Smartphone = 1, Tablet = 3, Desktop = 4 }
export enum ConnectionType { Wifi = 1, Cellular, }
export enum PropertyListTargetingMode { None = 0, Country, CountryRegion, CountryRegionCity, }
export enum OperatingSystemList { Android = 1, Ios, WindowsMobileOs }
export enum PropertyListViewability { NotVisibleNotEditableAndSelected = 0, VisibleNotEditableAndSelected, VisibleEditableAndNotSelected, VisibleEditableAndSelected }
export enum AdGroupSizeLevel { OneSize = 1, MultipleSizes, AllSizes }
export enum AdGroupCountryTargeting { HiddenTargeting = 1, HiddenCountry, DisabledCountry, OneCountry, MultipleCountries }
export enum AdGroupForecastMode { Free = 1, Packages }
export enum AdGroupForecastLabel { Value = 1, Percent }

// sponsorship
export enum SponsorshipTypeEnum { Newsletter = 1, Banner, Skin, Video, Social };
export enum SponsorshipPriceTypeEnum { Fixed = 1, Multi, Auction };
export enum SponsorshipFrequencyEnum { Daily = 1, Weekly, Monthly, Custom };
export enum SponsorshipVisibilityEnum { Public = 1, Private, Invitation };





// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/common/enum.ts